import { useApp } from '@/contexts/AppContext';
import { Wifi, WifiOff, Cloud, CloudOff, RefreshCw } from 'lucide-react';

export default function OfflineIndicator() {
  const { isOnline, pendingSyncCount, syncPendingChanges } = useApp();

  // Don't show anything if online and no pending changes
  if (isOnline && pendingSyncCount === 0) return null;

  return (
    <div 
      className={`fixed top-2 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium shadow-lg transition-all ${
        isOnline 
          ? 'bg-accent-amber/90 text-black' 
          : 'bg-red-500/90 text-white'
      }`}
      data-testid="offline-indicator"
    >
      {isOnline ? (
        <>
          <Cloud className="w-3.5 h-3.5" />
          <span>{pendingSyncCount} pending</span>
          <button 
            onClick={syncPendingChanges}
            className="p-1 hover:bg-black/10 rounded-full transition-colors"
            title="Sync now"
            data-testid="sync-now-btn"
          >
            <RefreshCw className="w-3 h-3" />
          </button>
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5" />
          <span>Offline{pendingSyncCount > 0 ? ` (${pendingSyncCount} pending)` : ''}</span>
        </>
      )}
    </div>
  );
}
